import type { FluxErrorCategories, FluxErrorCategoryMetadata } from '../errors.categories.js';
import { FLUX_ERROR_CATEGORIES } from '../errors.categories.js';
import type { FluxErrorCode } from '../errors.codes.js';

export function getFluxErrorCategory(errorCode: FluxErrorCode):
  | (FluxErrorCategoryMetadata & {
      key: FluxErrorCategories;
    })
  | null {
  const categoryKey = errorCode.split('/')[0] as FluxErrorCategories;

  const metadata = FLUX_ERROR_CATEGORIES[categoryKey];
  if (!metadata) {
    return null;
  }

  return {
    ...metadata,
    key: categoryKey,
  };
}
